var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalWizard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 70",
    style: {
      enableBackground: "new 0 0 102 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#E6E6E6;}\r\n\t.st1{fill:none;stroke:#E6E6E6;}\r\n\t.st2{fill:none;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#DADADA;stroke-miterlimit:10;}\r\n\t.st5{fill:#E6E6E6;}\r\n\t.st6{fill:none;stroke:#0072C6;stroke-width:2;}\r\n\t.st7{fill:#0072C6;stroke:#0072C6;stroke-miterlimit:10;}\r\n\t.st8{fill:#E6E6E6;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st9{fill:#0072C6;}\r\n\t.st10{fill:none;stroke:#0072C6;}\r\n\t.st11{fill:#E5E1DF;}\r\n\t.st12{fill:#F15A24;}\r\n\t.st13{fill:none;stroke:#F15A24;}\r\n\t.st14{opacity:0.6;fill:none;stroke:#D3D3D3;}\r\n\t.st15{fill:#D3D3D3;}\r\n\t.st16{fill:#616160;}\r\n\t.st17{fill:none;stroke:#616160;}\r\n\t.st18{fill:#FFFFFF;stroke:#DADADA;stroke-miterlimit:10;}\r\n\t.st19{opacity:0.5;}\r\n\t.st20{fill:none;stroke:#0072C6;stroke-miterlimit:10;}\r\n\t.st21{fill:none;stroke:#D3D3D3;}\r\n\t.st22{fill:none;stroke:#C4C4C4;stroke-width:0.5;}\r\n\t.st23{fill:#C4C4C4;}\r\n\t.st24{fill:none;stroke:#C4C4C4;stroke-width:2;}\r\n\t.st25{fill:#C5C4C4;}\r\n\t.st26{fill:none;}\r\n\t.st27{fill:#FFFFFF;stroke:#C4C4C4;stroke-miterlimit:10;}\r\n\t.st28{opacity:0.6;}\r\n\t.st29{fill:#006837;}\r\n\t.st30{opacity:0.6;fill:none;stroke:#D3D3D3;enable-background:new    ;}\r\n\t.st31{opacity:0.5;fill:#D3D3D3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 23.6788,
    y1: 6.0535,
    x2: 23.6788,
    y2: 63.9465
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 23.6788,
    y1: 22.4457,
    x2: 23.6788,
    y2: 31.3815
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M14.8652,7.0535c1.8726,0,3.3961,1.5235,3.3961,3.3961s-1.5235,3.3961-3.3961,3.3961 s-3.3961-1.5235-3.3961-3.3961S12.9926,7.0535,14.8652,7.0535 M14.8652,6.0535c-2.4279,0-4.3961,1.9682-4.3961,4.3961 s1.9682,4.3961,4.3961,4.3961s4.3961-1.9682,4.3961-4.3961S17.2932,6.0535,14.8652,6.0535L14.8652,6.0535z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M14.865,30.6063c-2.1484,0-3.896-1.748-3.896-3.8965s1.7476-3.8965,3.896-3.8965 s3.8965,1.748,3.8965,3.8965S17.0135,30.6063,14.865,30.6063z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M14.8652,23.3137c1.8726,0,3.3961,1.5235,3.3961,3.3962c0,1.8726-1.5235,3.3961-3.3961,3.3961 s-3.3961-1.5235-3.3961-3.3961C11.4691,24.8372,12.9926,23.3137,14.8652,23.3137 M14.8652,22.3137 c-2.4279,0-4.3961,1.9683-4.3961,4.3962s1.9682,4.3961,4.3961,4.3961s4.3961-1.9682,4.3961-4.3961 S17.2932,22.3137,14.8652,22.3137L14.8652,22.3137z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M14.8652,39.574c1.8726,0,3.3961,1.5235,3.3961,3.3961c0,1.8727-1.5235,3.3962-3.3961,3.3962 s-3.3961-1.5235-3.3961-3.3962C11.4691,41.0975,12.9926,39.574,14.8652,39.574 M14.8652,38.574 c-2.4279,0-4.3961,1.9682-4.3961,4.3961s1.9682,4.3962,4.3961,4.3962s4.3961-1.9683,4.3961-4.3962S17.2932,38.574,14.8652,38.574 L14.8652,38.574z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M14.8652,55.8342c1.8726,0,3.3961,1.5235,3.3961,3.3961s-1.5235,3.3961-3.3961,3.3961 s-3.3961-1.5235-3.3961-3.3961S12.9926,55.8342,14.8652,55.8342 M14.8652,54.8342c-2.4279,0-4.3961,1.9682-4.3961,4.3961 s1.9682,4.3961,4.3961,4.3961s4.3961-1.9682,4.3961-4.3961S17.2932,54.8342,14.8652,54.8342L14.8652,54.8342z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M16.551,9.3015c-0.7654,0.7654-1.5308,1.5308-2.2962,2.2962c-0.3584-0.3584-0.7168-0.7168-1.0752-1.0752"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.1797,
    y: 8.8554,
    className: "st31",
    width: 62.4719,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1797,
    y: 24.9453,
    className: "st31",
    width: 62.4719,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9551,
    y: 41.0351,
    className: "st31",
    width: 62.4719,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1797,
    y: 57.125,
    className: "st31",
    width: 62.4719,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalWizard2);
export default __webpack_public_path__ + "static/media/VerticalWizard2.dfc32e5327b21740586c30ba4a381e3d.svg";
export { ForwardRef as ReactComponent };